import Modal from 'react-responsive-modal';
import { useAuth } from '../../../../hooks/useAuth';

interface IModalGoal {
  modalIsOpen: boolean;
  toggleModal: () => void;
  percentage: number;
}

export function ModalGoal({
  modalIsOpen,
  toggleModal,
  percentage,
}: IModalGoal) {
  const { client } = useAuth();

  const getMonth = new Date(client.scaleStartDateEpoch).toLocaleString(
    'pt-BR',
    { month: 'long' }
  );
  const getYear = new Date(client.scaleStartDateEpoch).getFullYear();

  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal" style={{ padding: 0 }}>
        <div className="col-8 ms-4 mt-3">
          <p className="m-0 fw-semibold fs-5">Meta</p>
          <p className="text-capitalize">
            {getMonth}, {getYear}
          </p>
        </div>
        <div className="mx-4">
          <div className="d-flex flex-row">
            <div className="col-4">
              <div style={{ width: '120px' }} className="single-chart">
                <svg viewBox="0 0 36 36" className="circular-chart primary">
                  <path
                    className="circle-bg"
                    d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <path
                    className="circle"
                    strokeDasharray={`${percentage}, 100`}
                    d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                  />
                  <text
                    x="50%"
                    y="17"
                    style={{
                      dominantBaseline: 'middle',
                      textAnchor: 'middle',
                    }}
                    className="percentage"
                  >
                    {Math.round(percentage)}
                  </text>
                  <text
                    x="50%"
                    y="24"
                    style={{
                      dominantBaseline: 'middle',
                      textAnchor: 'middle',
                    }}
                    className="percentage-symbol"
                  >
                    por cento
                  </text>
                </svg>
              </div>
            </div>
            <div className="d-flex align-items-center flex-column w-100 mt-4 ms-3">
              <p className="m-0 tiny-text">Meta do mês</p>
              <p className="fs-2 m-0 color-text-primary">
                {client.scalePreset}
              </p>
              <p className="m-0 tiny-text">vendas</p>
            </div>
          </div>
        </div>
        <div className="mx-4 mt-4 mb-4">
          <p>{client.scaleDescription}</p>
        </div>
      </div>
    </Modal>
  );
}
